import React, { useState, useEffect, useRef, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Box, Button, Container, TextField, Typography } from '@material-ui/core'
import * as Yup from 'yup'
import { Formik } from 'formik'

// API
import { getPublicAPI, putPublicAPI } from '../api'

// components
import Loader from '../components/utils/Loader'

import { ToastContext } from '../contexts/Toast'

const ResetPasswordUser = () => {
    let mounted = useRef(true)

    const navigate = useNavigate()
    const { token0, token1, token2 } = useParams()
    const { setToasts } = useContext(ToastContext)

    const [loading, setLoading] = useState(true)
    const [user, setUser] = useState([])
    const [message, setMessage] = useState({ type: '', info: '' })

    useEffect(() => {
        setTimeout(() => {
            if (!token0) navigate('/404')
            mounted.current && setLoading(false)
        }, 1000)

        const prepareResetPassword = async () => {
            let resetPassword = await getPublicAPI('/validate-reset-password', {
                token: token0 + '.' + token1 + '.' + token2
            })

            if (mounted.current) {
                if (resetPassword?.success) setUser(resetPassword.data)
                else {
                    setMessage({ type: 'error', info: resetPassword?.errors[0].msg })
                    setToasts({
                        type: 'error',
                        messages: resetPassword?.errors
                    })
                }
            }
        }

        prepareResetPassword()

        return () => (mounted.current = false)
    }, [token0, token1, token2, navigate, setToasts])

    const onSubmit = async values => {
        try {
            if (values.password === values.confirmPassword) {
                let data = { id: user._id, fName: user.fName, email: user.email, pass: values.password }

                let resetPass = await putPublicAPI('/reset-password-user', data)

                console.log(resetPass)
                if (resetPass?.success) {
                    setToasts({
                        type: 'success',
                        messages: [{ msg: 'Password has been reset successfully' }]
                    })

                    navigate('/login', { replace: true })
                } else
                    setToasts({
                        type: 'error',
                        messages: resetPass?.errors
                    })
            } else
                setToasts({
                    type: 'error',
                    messages: [{ msg: 'Passwords do not match' }]
                })
        } catch (err) {
            setToasts({
                type: 'error',
                messages: [{ msg: `error in resetting password in ${err.message}` }]
            })
        }
    }

    let color = message.type === 'error' ? '#d22f25' : 'green'
    return (
        <>
            <Helmet>
                <title>{loading ? 'Loading...' : `Reset password | The HosePod`}</title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center'
                }}
            >
                <Container maxWidth={false}>
                    {loading ? (
                        <Loader />
                    ) : (
                        <>
                            {message.type ? (
                                <Box sx={{ textAlign: 'center', mt: '30vh' }}>
                                    <Typography sx={{ fontSize: '30px', color, fontWeight: 500 }}>
                                        {message.info || 'Something went wrong'}
                                    </Typography>
                                </Box>
                            ) : (
                                <Container maxWidth='sm'>
                                    <Formik
                                        initialValues={{
                                            password: '',
                                            confirmPassword: ''
                                        }}
                                        validationSchema={Yup.object().shape({
                                            password: Yup.string().min(7).required('Password is required'),
                                            confirmPassword: Yup.string()
                                                .min(7)
                                                .required('Please confirm the password')
                                        })}
                                        onSubmit={onSubmit}
                                    >
                                        {({
                                            errors,
                                            handleBlur,
                                            handleChange,
                                            handleSubmit,
                                            isSubmitting,
                                            touched,
                                            values
                                        }) => (
                                            <form onSubmit={handleSubmit}>
                                                <Box sx={{ mb: 3 }}>
                                                    <Typography color='textPrimary' variant='h2'>
                                                        Create password
                                       </Typography>
                                                    <Typography
                                                        color='textSecondary'
                                                        gutterBottom
                                                        variant='body2'
                                                    >
                                                        Create new password for your account
                                       </Typography>
                                                </Box>
                                                <TextField
                                                    error={Boolean(touched.password && errors.password)}
                                                    fullWidth
                                                    helperText={touched.password && errors.password}
                                                    label='New Password'
                                                    margin='normal'
                                                    name='password'
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    type='password'
                                                    value={values.password}
                                                    variant='outlined'
                                                />
                                                <TextField
                                                    error={Boolean(
                                                        touched.confirmPassword && errors.confirmPassword
                                                    )}
                                                    fullWidth
                                                    helperText={
                                                        touched.confirmPassword && errors.confirmPassword
                                                    }
                                                    label='Confirm New Password'
                                                    margin='normal'
                                                    name='confirmPassword'
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    type='password'
                                                    value={values.confirmPassword}
                                                    variant='outlined'
                                                />
                                                <Box sx={{ py: 2 }}>
                                                    <Button
                                                        color='primary'
                                                        disabled={isSubmitting}
                                                        fullWidth
                                                        size='large'
                                                        type='submit'
                                                        variant='contained'
                                                    >
                                                        Create password
                                       </Button>
                                                </Box>
                                            </form>
                                        )}
                                    </Formik>
                                </Container>
                            )}
                        </>
                    )}
                </Container>
            </Box>
        </>
    )
}

export default ResetPasswordUser
